import { TruncatedTextContent } from '@/features/truncated-text-content';
import { Container } from '@/shared/ui/Container';
import { twMergeExt } from '@/shared/utils/twMergeExt';
import { typograf } from '@/shared/utils/typograf';
import { cva, VariantProps } from 'class-variance-authority';
import { FC } from 'react';

interface Props extends VariantProps<typeof cvaInner> {
  className?: string;
  title: string;
  text: string;
  isTrunkated?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const CatalogCategoryAboutSection: FC<Props> = ({
  title,
  text,
  className,
  isTrunkated,
  mt,
  buttonText,
  onButtonClick,
}) => {
  return (
    <Container className={twMergeExt(cvaRoot(), className)} variant={'large'}>
      <div className={cvaInner({ mt })}>
        <h3
          className={cvaHeading()}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        ></h3>
        <div>
          {isTrunkated ? (
            <TruncatedTextContent
              className={cvaContent()}
              dangerouslySetInnerHTML={{
                __html: typograf.execute(text),
              }}
            ></TruncatedTextContent>
          ) : (
            <div
              className={cvaContent()}
              dangerouslySetInnerHTML={{
                __html: typograf.execute(text),
              }}
            ></div>
          )}
          {buttonText ? (
            <button type={'button'} className={cvaButton()} onClick={onButtonClick}>
              {buttonText}
            </button>
          ) : null}
        </div>
      </div>
    </Container>
  );
};

const cvaRoot = cva(['CatalogCategoryAboutSection-cvaRoot']);

export const cvaInner = cva(
  [
    'CatalogCategoryAboutSection cvaInner',
    'flex flex-col md:flex-row gap-2.4 md:gap-[10.6rem] lg:gap-[27.6rem]',
    'px-2 py-4 sm:p-8.8 rounded-[3.2rem]',
    'border border-cBlack16',
  ],
  {
    variants: {
      mt: {
        none: ['mt-0'],
        small: ['mt-[3.2rem] sm:mt-[4.8rem]'],
        large: ['mt-[6.4rem] sm:mt-[10.4rem]'],
      },
      mb: {
        none: ['mb-0'],
        small: ['mb-[3.2rem] sm:mb-[4.8rem]'],
        large: ['mb-[6.4rem] sm:mb-[10.4rem]'],
      },
    },
    defaultVariants: {
      mt: 'large',
      mb: 'large',
    },
  }
);

const cvaHeading = cva([
  'CatalogCategoryAboutSection-cvaHeading',
  'md:basis-[33.8rem] md:grow-0 md:shrink-0',
  'font-secondary text-h3',
]);

const cvaContent = cva(['CatalogCategoryAboutSection-cvaContent', 'text-bodyL text-cBlack80']);

const cvaButton = cva([
  'CatalogCategoryAboutSection-cvaButton',
  'text-bodyMSemibold underline underline-offset-4 decoration-cBlack32 hover:text-cMediumGreen hover:decoration-cMediumGreen',
  'transition-all duration-300',
  'mt-3.2',
]);
